import dayjs from "dayjs";
import {formatResponse} from "@breachrx/streaming";

export {formatResponse};

const getGreetingByTime = () => {
  const timeOfDay =
    dayjs().hour() < 12 ? "Morning" :
    dayjs().hour() < 18 ? "Afternoon" :
    "Evening";
  return `Good ${timeOfDay}! I'm RegScout, the BreachRx regulation expert agent. How may I help you with cybersecurity, privacy, and data breach regulations today?`;
};

export const getGreeting = () => ({
  text: getGreetingByTime(),
  sender: "assistant",
  isGreeting: true,
});
